import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { LOCALE_ID, Inject } from '@angular/core';

@Pipe({
  standalone: true,
    name: 'splitPrice',
})
export class SplitPricePipe implements PipeTransform {
    /**
     * @function splitPrice
     * @params {*} program - the entire program object
     * @params {nunber} arg[0] - number of weeks (optional)
     * @params {boolean} arg[1]- isMobile flag (optional)
     * @params {object} arg[2]- profile (optional)
     *
     * @description Divide the total price by the number of weeks. If no weeks passed in, return total price
     */

    constructor(@Inject(LOCALE_ID) public locale: string) {}

    transform(value: any, ...args: any): any {
        const program = value;

        let initialLoad = args;

        const totalPrice = program.price;
        const priceDropPrice = program.priceDropPrice;
        const numberWeeks = args[0];
        const isSmall = args[1];
        const profile = args[2];

        const enddateString =
            formatDate(program.pricedropenddate, 'MMM d, yyyy', this.locale, 'UTC') +
            ' ' +
            formatDate(program.pricedropenddate, 'hh:mm', this.locale, 'UTC') +
            '  ' +
            formatDate(program.pricedropenddate, 'O', this.locale, 'UTC');

        const endDateHtml = `<br><i class="bold-text-pricedrop-expires">Sale Ends: ${enddateString}</i>`;
        //
        // Only change the price if:
        // - number of weeks value is passed in
        // - it's not a program with custom availability
        //
        if (profile && profile.fieldofstudy && profile.fieldofstudy === 'Nurse Practitioner' && program.type.includes('Nurse Practitioner')) {
            const currencyPrice = new Intl.NumberFormat('en-US', {
                style: 'currency',
                currency: 'USD',
                minimumFractionDigits: 2,
            }).format(program.hourlyprice);

            return `<b class="bold-text">${currencyPrice || 'NA'} USD/hour</b>`;
        }

        if (program.customavailability) {
            // take min prices from custom availability
            if (program.customavailability.find((p) => p.price)) {
                if (!initialLoad[0]) {
                    return `<b class="bold-text">Select a Start Date to see pricing</b>`;
                }
                const customprice = this.findRange(program.customavailability);
                // check if custom availability has multiple prices
                if (customprice[0].length > 0) {
                    return `<b class="bold-text">$${customprice[0]} USD/week</b>`;
                    // check if only one price in custom availability
                } else if (customprice[0].length === 0) {
                    return `<b class="bold-text">$${customprice[1]} USD/week</b>`;
                } else {
                    // programs with custom availability with prices but its a empty string
                    return `<b class="bold-text">$${totalPrice} USD</b>`;
                }
            } else {
                // programs with custom availability with no prices field
                if (priceDropPrice) {
                    return `<b class="bold-text-line-through">$${totalPrice} USD</b> <b class="bold-text-pricedrop">$${priceDropPrice} USD</b>${endDateHtml}`;
                } else {
                    return `<b class="bold-text">$${totalPrice} USD</b>`;
                }
            }
        } else if (numberWeeks && typeof numberWeeks === 'number') {
            // divide the total price by the number of weeks
            // use Math.ceil to round up
            const pricePerWeek = Math.ceil(totalPrice / numberWeeks);

            if (isSmall) {
                return `<b class="bold-text">$${pricePerWeek}</b>/week`;
            } else {
                return `<b class="bold-text">$${totalPrice} USD</b>`;
            }
        } else {
            if (priceDropPrice) {
                return `<b class="bold-text-line-through">$${totalPrice} USD</b> <b class="bold-text-pricedrop">$${priceDropPrice} USD</b>${endDateHtml}`;
            } else {
                return `<b class="bold-text">$${totalPrice} USD</b>`;
            }
        }
    }

    findRange(arr: any) {
        let min = arr[0].price,
            max = arr[0].price;

        for (let i = 1, len = arr.length; i < len; i++) {
            let v = arr[i].price;
            min = v < min ? v : min;
            max = v > max ? v : max;
        }

        return [min, max];
    }
}
